module.exports = __webpack_public_path__ + "static/media/hourglass.463714ef.svg";